<template>
  <div class="controls-layout" id="paginator">
    <button @click="goto(start)" class="button control" id="paginator_start">
      <font-awesome-icon icon="angle-double-left"/>
    </button>

    <button @click="goto(prev)" class="button control" id="paginator_prev">
      <font-awesome-icon icon="angle-left"/>
    </button>

    <div class="text-primary flex items-center ph3 bg-white ma0 pa0">
      {{page}} из {{total}}
    </div>

    <button @click="goto(next)" class="button control" id="paginator_next">
      <font-awesome-icon icon="angle-right"/>
    </button>

    <button @click="goto(end)" class="button control" id="paginator_end">
      <font-awesome-icon icon="angle-double-right"/>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    resource: { type: String },
    page: { default: 1 },
    total: { default: 1 },
    routing: { default: true }
  },
  computed: {
    resource_name () {
      return this.resource || this.$router.currentRoute.name
    },
    start () {
      return { name: this.resource_name, query: { page: 1 } }
    },
    prev () {
      return { name: this.resource_name, query: { page: Math.max(1, +this.page - 1) } }
    },
    next () {
      return { name: this.resource_name, query: { page: Math.min(+this.page + 1, this.total) } }
    },
    end () {
      return { name: this.resource_name, query: { page: this.total } }
    }
  },
  methods: {
    goto (where) {
      if (this.routing) {
        this.$router.push(where)
      }
      this.$emit('goto', where)
    }
  }
}
</script>

<style lang="scss" scoped>
.controls-layout {
  display: grid;
  grid-template-columns: 50px 50px auto 50px 50px;
  grid-template-rows: 50px;
  grid-gap: 1px;
  border-radius: 0rem;
  overflow: hidden;
}
.control {
  background-color: white;
  padding: 1rem;
  font-size: 1rem;
  color: #334E68;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
</style>
